import React from 'react';
import variables from '@sicredi/styles/_variables.scss';
import styles from '@sicredi/styles/_radio.scss';
import { Icon } from '../icon';

interface RadioIconProps {
  checked?: boolean;
  style?: { [key: string]: any };
}
const RadioIcon = ({
  checked,
  style = {},
}: RadioIconProps) => {
  const commonStyles = {
    transition: `opacity ${variables.animationTiming}`,
    right: 0,
    ...style,
  };
  return (
    <span className={styles['icon']} style={{ position: 'relative' }}>
      <Icon
        name="radio-filled"
        style={{
          ...commonStyles,
          opacity: Number(checked),
          position: 'absolute'
        }}
      />
      <Icon
        name="radio"
        style={{
          ...commonStyles,
          opacity: Number(!checked),
          position: 'absolute'
        }}
      />
    </span>
  );
};

export default RadioIcon;
